import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../axios";

const useDeleteAdminMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (adminId) => {
      const response = await axios.delete(`/api/sellerprofile?_id=${adminId}`);
      return response.data;
    },
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["admins"]);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export default useDeleteAdminMutation;
